import React, { useEffect, useState } from "react";
import "../styles/Users.scss";
import { useNavigate, useParams } from "react-router-dom";
import {
  createUser,
  getUserInfo,
  getUsersByRole,
  getUsersByRoleId,
  updateUser,
} from "../services/api";
import Swal from "sweetalert2";
import Select from "react-select";

function EditUser() {
  const { id: userId } = useParams();

  // To display in usertypes
  const userTypes = [
    { id: 3, value: "Hiring Manager", label: "Hiring Manager" },
    { id: 4, value: "Recruiter", label: "Recruiter" },
  ];

  // For integration - fields

  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    doj: "",
    notes: "",
    reportingManager: "",
    role_id: 4,
  });

  const [reportingManagerInfo, setReportingManagerInfo] = useState(null);
  const [managerOptions, setManagerOptions] = useState([]);

  const roleId = localStorage.getItem("role_id");
  const reportingManagerUserId = localStorage.getItem(
    "reporting_manager_user_id"
  );

  const [error, setError] = useState("");
  const [emailError, setEmailError] = useState("");
  const navigate = useNavigate();

  // For usertype change
  const handleUserTypeChange = (selected) => {
    setForm((f) => ({ ...f, userType: selected ? selected.value : "" }));
  };

  // For Reporting manager
  const handleManagerChange = (selected) => {
    setForm((f) => ({
      ...f,
      reportingManager: selected ? selected.value : "",
    }));
  };

  // Fetch reporting manager information
  const fetchReportingManagerInfo = async (managerId) => {
    if (!managerId) return;

    try {
      const managerData = await getUserInfo(managerId);
      if (managerData.status === "S") {
        setReportingManagerInfo(managerData.result_info);
      }
    } catch (error) {
      console.error("Error fetching reporting manager info:", error);
    }
  };

  useEffect(() => {
      const fetchHRUsers = async () => {
        try {
          const res = await getUsersByRoleId(3); // Fetch role_id 3 users (HR/Hiring Managers)
          if (res && res.status === "S" && Array.isArray(res.result_info)) {
            setManagerOptions(
              res.result_info.map((mgr) => ({
                value: mgr.id,
                label: mgr.name + (mgr.email ? ` (${mgr.email})` : ""),
              }))
            );
          } else {
            setManagerOptions([]);
          }
        } catch (error) {
          console.error("Error fetching HR users:", error);
          setManagerOptions([]);
        }
      };
  
      // Always fetch HR users for the reporting manager dropdown
      fetchHRUsers();
    }, []);

  // Effect to handle managerOptions loading and form synchronization
  useEffect(() => {
    if (managerOptions.length > 0 && form.reportingManager) {
      const foundManager = managerOptions.find(opt => opt.value === form.reportingManager);
      if (!foundManager) {
        // If the current reporting manager is not in the options, clear it
        setForm(prev => ({ ...prev, reportingManager: "" }));
      }
    }
  }, [managerOptions, form.reportingManager]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        Swal.fire({
          html: `<img src=${require("../assets/loader.gif")} style="width: 50px" alt="loader">`,
          showConfirmButton: false,
          heightAuto: false,
          customClass: { popup: "loader-swal" },
          allowOutsideClick: false,
        });

        const apiData = await getUserInfo(userId);
        Swal.close();

        if (apiData.status === "S") {
          setForm({
            ...apiData.result_info,
            userType: apiData.result_info.role_id || 4,
            doj: apiData.result_info.doj || "",
            reportingManager: apiData.result_info.reporting_manager_user_id || "",
          });

          // Fetch reporting manager info if user is a recruiter (role_id 4)
          if (
            apiData.result_info.role_id === 4 &&
            apiData.result_info.reporting_manager_user_id
          ) {
            await fetchReportingManagerInfo(
              apiData.result_info.reporting_manager_user_id
            );
          }
        } else {
          setForm({
            name: apiData.name || "",
            email: apiData.email || "",
            mobile: apiData.mobile || "",
            userType: apiData.role_id || "Recruiter", // Default to Recruiter if role_id is not set
            doj: apiData.doj || "",
            notes: apiData.notes || "",
            reportingManager: apiData.reporting_manager_user_id || "",
          });
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
        Swal.close();
        Swal.fire({
          text: "Failed to fetch user data.",
          icon: "error",
          timer: 3000,
          showConfirmButton: false,
        });
        setForm({
          name: "",
          email: "",
          mobile: "",
          role_id: 4,
          doj: "",
          notes: "",
          reportingManager: "",
        });
      }
    };

    if (userId) {
      fetchData();
    }
  }, [userId]);

  const handleSubmit = async () => {
    let emalval = new RegExp(
      "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,4}$"
    );
    if (!form.name) {
      Swal.fire({
        title: 'Missing Name',
        text: "Please provide name!",
        icon: "warning",
        
      });
    } else if (form.name.length > 75) {
      Swal.fire({
        title: 'Invalid Length',
        text: "Name should be less than 75 characters",
        icon: "warning",
        
      });
    }
    else if (!form.mobile) {
          Swal.fire({
            title: 'Missing Mobile Number',
            text: "Please enter Mobile Number",
            icon: "warning",
            
          });
        
        } else if (form.mobile.length < 10) {
          Swal.fire({
            title: "Invalid Mobile Number",
            text: "Please enter a valid mobile number",
            icon: "warning",
            
          });
        }
    // else if (form.email && !emalval.test(form.email)) {
    //     Swal.fire({
    //         text: "Please enter valid Email",
    //         icon: "warning",
    //         showConfirmButton: false,
    //         heightAuto: false,
    //         timer: 1500,
    //     });
    // } else if (form.email.length > 255) {
    //     Swal.fire({
    //         text: "Email should be less than 255 characters",
    //         icon: "warning",
    //         showConfirmButton: false,
    //         heightAuto: false,
    //         timer: 1500,
    //     });
    // }
    // else if (!form.doj) {
    //     Swal.fire({
    //         text: "Please select date of joining",
    //         icon: "warning",
    //         showConfirmButton: false,
    //         heightAuto: false,
    //         timer: 1500,
    //     });
    // }
    //  else if(!form.role_id){
    //     Swal.fire({
    //         text: "Please select usetype",
    //         icon: "warning",
    //         showConfirmButton: false,
    //         heightAuto: false,
    //         timer: 1500,
    //     });
    // }
    // else if (form.role_id === 4 && !form.reportingManager) {
    //     Swal.fire({
    //         text: "Please select reporting manager",
    //         icon: "warning",
    //         showConfirmButton: false,
    //         heightAuto: false,
    //         timer: 1500,
    //     })
    // }
    else {
      const payload = {
        name: form.name.trim(),
        email: form.email.trim(),
        mobile: form.mobile.trim(),
        role_id: form.role_id,
        reporting_manager_user_id: form.reportingManager,
        doj: form.doj,
        notes: form.notes.trim(),
      };
      Swal.fire({
        html: `<img src=${require("../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });
      let apiData = await updateUser(userId, payload);
      Swal.close();
      console.log(apiData);
      if (apiData.status === "S") {
        Swal.fire({
          text: "User updated successfully!",
          showConfirmButton: false,
          icon: "success",
          timer: 1500,
        }).then(() => {
          navigate("/users");
        });
      }
      // if (apiData.status === "E" && apiData.status_code === "300") {
      //     Swal.fire({
      //     text: "Email is already taken",
      //     showConfirmButton: false,
      //     icon: "warning",
      //     timer: 3000,
      //     });
      // }
      // if (apiData.status === "E" && apiData.status_code === "302") {
      //     Swal.fire({
      //     text: "License limit exceeded!",
      //     showConfirmButton: false,
      //     icon: "warning",
      //     timer: 3000,
      //     });
      // }
      else if (apiData.status === "E") {
        Swal.fire({
          text: apiData.message,
          showConfirmButton: false,
          icon: "warning",
          timer: 3000,
        });
      }
      if (
        apiData.status === "F" &&
        apiData.message === "Unauthorized - Missing token"
      ) {
        Swal.fire({
          text: "Please login with your credentials",
          icon: "warning",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          localStorage.clear();
          navigate("/login");
        });
      }
      if (
        apiData.status === "F" &&
        apiData.message === "Unauthorized - Invalid token"
      ) {
        Swal.fire({
          text: "Please login with your credentials",
          icon: "warning",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          localStorage.clear();
          navigate("/login");
        });
      }
    }
  };

  return (
    <div className="users-page">
      <div className="user-create-container">
        <h2 style={{ fontWeight: 600, fontSize: "1.3rem" }}>Edit User</h2>
        <div className="user-create-form">
          <div className="user-section">
            <div className="user-section-title">User Details</div>
            <div className="user-row">
              <div className="user-field" style={{ minWidth: 0 }}>
                <label>Name *</label>
                <input
                  name="name"
                  value={form.name}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    // Don't allow if it doesn't start with a letter (but allow empty string)
                    if (value !== "" && !/^[a-zA-Z]/.test(value)) {
                      return; // Reject if doesn't start with letter
                    }
                    // Prevent consecutive spaces
                    if (/\s{2,}/.test(value)) {
                      return; // Reject if two or more spaces occur consecutively
                    }
                    const invalidPattern =
                      /<script.*?>.*?<\/script>|[<>\\{}=:/""'']/i;
                    if (!invalidPattern.test(value)) {
                      setForm({ ...form, name: value });
                    }
                  }}
                  maxLength={75}
                  required
                  placeholder="Enter full name"
                  className="custom-placeholder"
                  autoComplete="off"
                />
              </div>
              <div className="user-field" style={{ minWidth: 0 }}>
                <label htmlFor="email">Email *</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={form.email}
                  disabled
                  onChange={(ev) => {
                    const value = ev.target.value;
                    const emailPattern =
                      /^[a-zA-Z0-9._%+-]+(@[a-zA-Z0-9.-]*)?$/;
                    if (value && emailPattern.test(value)) {
                      setForm({ ...form, email: value });
                    } else if (!value) {
                      setForm({ ...form, email: "" });
                    }
                    // UpwardIQ restriction logic
                    if (
                      !value
                        .toLowerCase()
                        .endsWith["@upwardiq.com, @impaxivesolutions.com"]
                    ) {
                      setEmailError(
                        "Only upwardiq emails are allowed (must end with @upwardiq.com)."
                      );
                    } else {
                      setEmailError("");
                    }
                  }}
                  onBlur={(ev) => {
                    setEmailError("");
                  }}
                  maxLength={75}
                  required
                  placeholder="Enter company email address"
                  className="custom-placeholder"
                  autoComplete="off"
                  title="Gmail addresses are not allowed. Please use your company email."
                />
                {emailError && (
                  <div
                    style={{
                      color: "#e53e3e",
                      fontSize: "0.95em",
                      marginTop: 2,
                    }}
                  >
                    {emailError}
                  </div>
                )}
              </div>
            </div>
            <div className="user-row">
              <div className="user-field" style={{ minWidth: 0 }}>
                <label>Mobile *</label>
                <input
                  name="mobile"
                  value={form.mobile}
                  // onChange={(ev) => {
                  //   const value = ev.target.value;
                  //   const mobilePattern =
                  //     /^\d{10}$/;
                  //   if (value && mobilePattern.test(value)) {
                  //     setForm({ ...form, mobile: value });
                  //   } else if (!value) {
                  //     setForm({ ...form, mobile: "" });
                  //   }
                  // }}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    
                    // Allow only digits and limit to 10 characters max
                    if (/^\d{0,10}$/.test(value)) {
                      setForm({ ...form, mobile: value });
                    }
                  }}
                  maxLength={10}
                  placeholder="Enter mobile number"
                  className="custom-placeholder"
                  autoComplete="off"
                />
              </div>
              <div className="user-field" style={{ minWidth: 0 }}>
                <label>User Type *</label>
                <Select
                  options={userTypes}
                  value={
                    userTypes.find((type) => type.id === form.role_id) || null
                  }
                  onChange={(selected) =>
                    setForm((f) => ({
                      ...f,
                      role_id: selected ? selected.id : 4,
                    }))
                  }
                  placeholder="Select user type"
                  isSearchable={true}
                  classNamePrefix="react-select"
                  isDisabled={true}
                  sx={{ padding: "0.55rem 0.8rem" }}
                />
              </div>
            </div>
            {form.role_id === 4 ? (
              <div className="user-row">
                {/* Show reporting manager field if userType is Recruiter (role_id 4) */}

                <div className="user-field" style={{ minWidth: 0 }}>
                  <label>Reporting Manager</label>
                  <Select
                    name="reportingManager"
                    value={
                      managerOptions.find(
                        (opt) => opt.value === form.reportingManager
                      ) || null
                    }
                    onChange={handleManagerChange}
                    options={managerOptions}
                    placeholder="Select Reporting Manager"
                    isSearchable={true}
                    isClearable
                    classNamePrefix="react-select"
                    autoComplete="off"
                  />
                </div>
                <div className="user-field" style={{ minWidth: 0 }}>
                  <label>Date of Joining</label>
                  {/* <input
                        name="doj"
                        type="date"
                        value={form.doj}
                        onChange={(ev) => {
                            setForm((prevForm) => ({
                                ...prevForm,
                                doj: ev.target.value,
                            }));
                        }}
                        className="custom-date-input"
                        autoComplete='off'
                    /> */}

                  <input
                    type="date"
                    value={form.doj}
                    onChange={(e) => setForm({ ...form, doj: e.target.value })}
                    className="custom-date-input"
                  />
                </div>
              </div>
            ) : (
              <div className="user-field" style={{ minWidth: 0 }}>
                <label>Date of Joining</label>
                {/* <input
                        name="doj"
                        type="date"
                        value={form.doj}
                        onChange={(ev) => {
                            setForm((prevForm) => ({
                                ...prevForm,
                                doj: ev.target.value,
                            }));
                        }}
                        className="custom-date-input"
                        autoComplete='off'
                    /> */}

                <input
                  type="date"
                  value={form.doj}
                  onChange={(e) => setForm({ ...form, doj: e.target.value })}
                  className="custom-date-input"
                />
              </div>
            )}
          </div>

          <div className="user-section">
            <div className="user-section-title">Additional Notes</div>
            <textarea
              className="user-notes custom-placeholder"
              name="notes"
              value={form.notes}
              onChange={(ev) => {
                const value = ev.target.value;
                const invalidPattern =
                  /<script.*?>.*?<\/script>|[<>\\{}=:/""'']/i;
                if (!invalidPattern.test(value)) {
                  setForm({ ...form, notes: value });
                }
              }}
              placeholder="Add any additional notes about the user"
              rows="2"
              autoComplete="off"
              
            />
          </div>
          {error && (
            <div
              style={{ color: "#e53e3e", marginBottom: 10, fontWeight: 500 }}
            >
              {error}
            </div>
          )}
          <div className="user-actions justify-content-center">
            <button
              className="cancel-btn"
              type="button"
              onClick={() => navigate("/users")}
            >
              Cancel
            </button>
            <button className="save-btn" onClick={handleSubmit}>
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditUser;
